import { Link, useLocation } from "react-router-dom";
import { Mic, PenLine, BookOpen, Briefcase, Sparkles } from "lucide-react";

// Five hubs on mobile. Outcome-oriented labels. Pricing lives in the
// profile menu / Penny upsell, not in the always-visible bottom bar.
const TABS = [
  { to: "/speak",    icon: Mic,       label: "Speak",    match: ["/speak", "/conversations", "/conversation-practice", "/oral", "/listening", "/voice-recorder", "/pronunciation", "/speak-practice"] },
  { to: "/write",    icon: PenLine,   label: "Write",    match: ["/write"] },
  { to: "/practice", icon: BookOpen,  label: "Practice", match: ["/practice", "/lesson", "/vocabulary", "/stories", "/idioms", "/reading", "/mini-games", "/phrases", "/topics"] },
  { to: "/career",   icon: Briefcase, label: "Career",   match: ["/career"] },
  { to: "/penny",    icon: Sparkles,  label: "Penny",    match: ["/penny", "/dashboard", "/progress", "/achievements", "/history", "/calendar", "/bookmarks", "/leaderboard"] },
];

export default function BottomNav() {
  const { pathname } = useLocation();

  return (
    <nav
      className="md:hidden"
      style={{
        position: "fixed",
        bottom: 0, left: 0, right: 0,
        zIndex: 40,
        background: "var(--paper)",
        borderTop: "2px solid var(--border-2)",
      }}
      aria-label="Primary"
    >
      <div style={{ display: "flex", justifyContent: "space-around", alignItems: "center", height: 68, padding: "0 4px" }}>
        {TABS.map((tab) => {
          const Icon = tab.icon;
          const isActive = tab.match.some((p) => pathname === p || pathname.startsWith(p + "/")) || (tab.to === "/penny" && pathname === "/dashboard");

          return (
            <Link
              key={tab.label}
              to={tab.to}
              aria-current={isActive ? "page" : undefined}
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: 2,
                padding: "6px 12px",
                borderRadius: 14,
                minWidth: 58,
                background: isActive ? "var(--feather-soft)" : "transparent",
                border: isActive ? "2px solid var(--sage-light)" : "2px solid transparent",
                color: isActive ? "var(--feather-dark)" : "var(--ink-500)",
                textDecoration: "none",
                position: "relative",
                transition: "background 160ms var(--ease-spring), color 160ms var(--ease-spring)",
              }}
            >
              <Icon
                size={23}
                strokeWidth={2.4}
                className={isActive ? "anim-pop" : ""}
                color={isActive ? "var(--feather-dark)" : "currentColor"}
              />
              <span style={{ fontSize: 10, fontWeight: isActive ? 800 : 700, letterSpacing: 0.2 }}>{tab.label}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
